import { paths } from '~/paths'
import { useQueryParam } from '~/hooks/useQueryParam'

const createLinkWithQueryParams = (url: string, params: Record<string, unknown> = {}) => {
  const nonNullParams = Object.keys(params)
    .filter((key) => !!params[key])
    .reduce(
      (acc, key) => ({
        ...acc,
        [key]: params[key],
      }),
      {}
    )

  const queryString = new URLSearchParams(nonNullParams).toString()
  return queryString ? `${url}?${queryString}` : url
}

export const links = {
  recoveryLink: (referrer?: string | null) => createLinkWithQueryParams(`/${paths.RECOVERY}`, { referrer }),
  welcomeLink: () => `/${paths.WELCOME}`,
  signInLink: (referrer?: string | null) => createLinkWithQueryParams(`/${paths.SIGN_IN}`, { referrer }),
  signUpLink: (referrer?: string | null) => createLinkWithQueryParams(`/${paths.SIGN_UP}`, { referrer }),
  signUpSuccessLink: () => `/${paths.SIGN_UP}/${paths.SUCCESS}`,
}

export const useSignInLink = () => {
  const referrer = useQueryParam('referrer')
  return links.signInLink(referrer)
}

export const useSignUpLink = () => {
  const referrer = useQueryParam('referrer')
  return links.signUpLink(referrer)
}

export const useRecoveryLink = () => {
  const referrer = useQueryParam('referrer')
  return links.recoveryLink(referrer)
}
